export class ServicesProvided
{
    public memberId: number;
    public caseId: number;
    public taskId: string;
    public serviceDate: any;
    public comments: string = null;
    public billableServices: number[] = [];
}